import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import store from './state/index'
import { Provider } from 'react-redux'
import { QueryClient, QueryClientProvider } from 'react-query'
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './i18n';
import { installClientErrorReporting } from './utils/clientErrors';
import { installAnalytics } from './utils/analytics';

installClientErrorReporting();
installAnalytics();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Keep cache across React 18 StrictMode remounts to avoid duplicate fetches
      cacheTime: 1000 * 60 * 1, // 1 minutes
      staleTime: 1000 * 10,     // 10 seconds fresh
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
})

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App/>
        </BrowserRouter>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

// The app has no service worker any more: it kept serving an old build after a deploy.
// One left from an earlier visit is removed here, and by public/service-worker.js from its side.
navigator.serviceWorker
  ?.getRegistrations()
  .then((registrations) => registrations.forEach((registration) => registration.unregister()))
  .catch(() => undefined);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
